
import Raven from 'raven-js';
import { IGeoDatabase } from '@idha/idha-utils';
import { loginModule } from '../login-module';
import { LoggedUser } from "../../../redux/structures";
import { Account } from "@idha/idha-types";
import * as loggedUserActions from "../../../redux/actions/loggedUser.actions";
import * as accessPermissionActions from "../../../redux/actions/accessPermissions.actions";
import * as storeData from "../../../redux/store/store"
import { hideUserExchangeDialog } from 'redux/actions/users.actions';
import { packingApi } from 'api/packingApi';
import { ordersApi } from "api/ordersApi";
import { accountsApi } from 'api/accountsApi';


loginModule.factory('LoginService', ['$state', 'UserIdha', 'Person', 'localStorageService', 'cacheService', 'LoggedUserService', '$location', 'geoDBService', '$window', 'Account', '$ngRedux',function ($state, UserIdha, Person, localStorageService, cacheService, LoggedUserService, $location, geoDBService: IGeoDatabase, $window, Account,$ngRedux) {


    let loginService = {
        /**
         *
         * @param {type} username
         * @param {type} password
         * @returns {$q@call;defer.promise}
         */
        login: async function (username, password, options?:{stayInRoute?:boolean,goToUrl?:string,goToState?:string}) {
            try {
                $ngRedux.dispatch(hideUserExchangeDialog());

                const { userId } = await UserIdha.login({
                    username: username,
                    password: password
                }).$promise

                const accessToken: string = window.localStorage.getItem('$LoopBack$accessTokenId');

                let loggedUser = await setupLoggedUserForLocalStorage(userId,accessToken);

                await loginService.onUserLoggedIn(loggedUser);


                geoDBService.setToken(accessToken);

                if(options?.stayInRoute) return;

                if(options?.goToState){
                    $state.go(options?.goToState)
                }else if(options?.goToUrl){
                    $window.location.href = options.goToUrl;
                }else{
                    await storeData.persistor.flush();
                    $window.location.href = 'app.html#/'
                }
            } catch (err) {
                console.error(err)
                $window.localStorage.clear()
                throw err;
            }
        },


        logout: async function (options?:{stayInRoute?:boolean,goToUrl?:string,goToState?:string, params?:{[key:string]:string}}) {

            try{
                //localStorageService.remove('loggedUser');
                //localStorageService.remove("ownerId");
                //localStorageService.remove("permissions");
                $window.localStorage.clear();

                // @TODO tive que remover na refatoração uma vez que esta chamada cria uma dependência com currentTags que
                // depende de muitas outras coisasa ligdas especificamente ao módulo de etiquetas. jonthan
                // currentTags.reset();
                cacheService.clearAllCaches();
                // @TODO idem ao currentTags
                // currentOrder.resetOrder();
                UserIdha.logout();
            }finally{
                console.log('Logging out...')
                setTimeout(()=>{
                    //Querystring deve ter o formato:   ?param1=value&pram2=value....paramN=value
                    const queryString = options?.params ? Object.keys(options.params).reduce<string>((paramStr,key,index)=>{
                        const symbol = index > 0 ? '&' : '?';
                        return `${paramStr}${symbol}${key}=${options.params[key]}`
                    },'') : '';

                    if(options?.stayInRoute) return;

                    if(options?.goToState){
                        $state.go(options?.goToState + queryString)
                    }else if(options?.goToUrl){
                        $window.location.href = options.goToUrl + queryString;
                    }else{
                        $window.location.href = "login.html#/" + queryString
                    }
                },1)
            }
        },


        reloadLoggedUser: async function(){
            var unsubscribeRedux = $ngRedux.connect(state => ({ loggedUser: state.loggedUser }))(this);

            this.loggedUser = await setupLoggedUserForLocalStorage(this.loggedUser?.id);
            loginService.onUserLoggedIn(this.loggedUser);

            unsubscribeRedux();
            return this.loggedUser;
        },


        onUserLoggedIn: async function (loggedUser) {
            if(!loggedUser) return;
            // configurar o usuário atual no sentry
            Raven.setUserContext({
                email: loggedUser.email,
                id: loggedUser.id
            })
            UserIdha.updateLastAccess({ id: loggedUser.id });

            var unsubscribeRedux = $ngRedux.connect(state => ({ selectedAccount: state.selectedAccount }))(this);

            const token = localStorage.getItem("$LoopBack$accessTokenId")

            if (loggedUser?.personInformation?.isAgency && (await accountsApi.Agency.findOne({
                params: {
                    filter: {
                        where: {
                            OWNER_ID: loggedUser.personInformation.ownerId
                        }
                    }
                },
                headers: {
                    Authorization: token
                }
            }))?.defaultIdentityCardModelId == null) {
                alert(`Modelo padrão de carteirinha não definido para a agência. Entre em contato com o suporte da Idha`)
                await this.logout()
            }

            $ngRedux.dispatch(loggedUserActions.userLoggedIn({
                ...loggedUser,
                token: token
            }));


            $ngRedux.dispatch(accessPermissionActions.setupPermissions(loggedUser,this.selectedAccount));

            unsubscribeRedux();
            return loggedUser;

        },

        isLogged: function () {
            return (LoggedUserService.loggedUser != undefined) && (!isEmpty(window.localStorage.getItem('$LoopBack$accessTokenId')))

            function isEmpty(str: string) {
                return (str == "") || (str == undefined)
            }
        }
    };


    return loginService;

    async function setupLoggedUserForLocalStorage(userId?:string,token?:string):Promise<LoggedUser>{
        const userFromServer = await UserIdha.findById({ id: userId, filter: { include: ['person', 'roles', 'currentPhoto','vehicles'] } }).$promise;

        const person = await Person.findById({
            id: userFromServer.personId, filter: {
                include: ['permissions']
            }
        }).$promise;

        let ownerId = person[person.identifier.toLowerCase()];
        localStorageService.set("ownerId", ownerId);

        const loggedUser = adjustToLoggedUserStructure(userFromServer)

        loggedUser.personInformation.permissions = person.toJSON().permissions.map(permission => ({ id: permission.id, identifier: permission.identifier }))

        const isAgencyInfo = await checkIfLoggedUserIsAgency()
        loggedUser.personInformation.isAgency = isAgencyInfo.isAgency;
        loggedUser.allowAccessAgency = isAgencyInfo.isAuthorized;

        const isBankInfo = await checkIfLoggedUserIsBank()
        loggedUser.personInformation.isBank = isBankInfo.isBank;
        loggedUser.allowAccessBank = isBankInfo.isAuthorized;

        loggedUser.personInformation.isClient = await checkIfLoggedUserIsisClient()

        loggedUser.personInformation.id = userFromServer.personId

        loggedUser.personInformation.ownerId = localStorageService.get('ownerId').replace(/\"/g,"")

        loggedUser.personInformation.bankId = await getBankId(ownerId,token)

        return loggedUser;

        async function checkIfLoggedUserIsAgency(): Promise<{ isAgency:boolean, isAuthorized:boolean }> {
            let isAgency

            try {


                let accounts: Account[] = await Account.find(
                    {
                        filter: {

                            where: {
                                or: [
                                    { accountType: 'BANK' },
                                    { accountType: 'AGENCY' }
                                ]
                            }
                        }
                    }).$promise;

                let isAgency = false
                let isAuthorized = false
                const agencyAccount = accounts.find(account => (account.accountType == 'AGENCY'));
                if (agencyAccount){
                    isAgency = true
                    const permissions = accessPermissionActions.setupPermissions(loggedUser, agencyAccount).permissions;
                    isAuthorized = permissions.packing.accessAgencyAccount
                }

                return { isAgency, isAuthorized }

            } catch (error) {
                if (error.status == 401) {
                    isAgency = false
                } else {
                    Raven.captureException(error)
                }
            }

            return isAgency


        }

        async function checkIfLoggedUserIsBank() : Promise<{ isBank:boolean, isAuthorized:boolean }> {
            let isBank = false;
            let isAuthorized = false;

            try {


                let accounts: Account[] = await Account.find(
                    {
                        filter: {
                            where: {
                                accountType: 'BANK'
                            },
                            include: ['bank']
                        }
                    }).$promise;

                isBank = accounts?.length > 0;
                if (isBank){
                    isAuthorized = accounts.find(account => accessPermissionActions.setupPermissions(loggedUser,account).permissions.packing.accessBankAccount) != undefined; 
                }

                return { isBank, isAuthorized }

            } catch (error) {
                if (error.status == 401) {
                    debugger
                    isBank = false
                } else {
                    Raven.captureException(error)
                }
            }

            return { isBank, isAuthorized }
        }

        async function getBankId(ownerId:string,token:string) {
            try {
                const [bank] = await packingApi.Bank.find({
                    params: {
                        filter: {
                            where: {
                                OWNER_ID: ownerId
                            }
                        }
                    },
                    headers: {
                        Authorization: token
                    }
                })

                return bank?.id?.toString?.()
            } catch (error) {
                return null
            }
        }

        async function checkIfLoggedUserIsisClient() : Promise<boolean> {
            let isClient

            try {

                let stores = await ordersApi.Loja.findByClientDocument(ownerId, {
                    headers: {
                        Authorization: window.localStorage.getItem('$LoopBack$accessTokenId'),
                    },
                });

                isClient = stores.length > 0

            } catch (error) {
                isClient = false
            }

            return isClient
        }
        function adjustToLoggedUserStructure(user): LoggedUser {
            let loggedUser = new LoggedUser()

            loggedUser = Object.assign(loggedUser, user)
            loggedUser.isLogged = true

            loggedUser.roles = user.roles.map(role => ({ id: role.id, name: role.name }))

            return loggedUser
        }
    }

}]);